// extracted by mini-css-extract-plugin
export default {"excerpt":"excerpt_excerpt__zXsP+","dark":"excerpt_dark__TaCh1","light":"excerpt_light__tngsu"};